import { green, amber, red, blue } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

export const __ENV__ = process.env.REACT_APP_ENV;

export let dashboard_url = "http://go-bus.com:7002";

if ("production" === __ENV__) {
  dashboard_url = process.env.REACT_APP_BACKEND;
}

if ("local" === __ENV__) {
  dashboard_url = "http://localhost:2121";
  // dashboard_url = "http://go-bus.com:7001";
}

if (process.env.REACT_APP_BACKEND) {
    dashboard_url = process.env.REACT_APP_BACKEND;
}

console.log("ENV: ", __ENV__);
console.log("BE: ", dashboard_url);

export const input = {
  triggerDelay: 450, // delay in milliseconds that after it the timeout triggers
}

export const timers = {
  alertHide: 3500, // delay in milliseconds to hide alert msgs after
  inputTrigger: 450, // delay in milliseconds starting from user typing to trigger and action after
}

export const cardTypes = {
  cc: 3,
  cash: 2
};

export const cardStatuses = {
  pending: 3,
  paid: 4,
  cancelled: -1
};

export const userPermissions = {
  viewBookings: "view_bookings",
  viewCustomers: "view_customers",
  viewSettings: "view_settings",
  //viewRatings: "view_ratings", //[RATINGS] - need to be added in the back end
}

export function getStatus(statusCode) {
  switch (statusCode) {
    case cardStatuses.paid:
      return "confirmed";
    case cardStatuses.pending:
      return "pending";
    case cardStatuses.cancelled:
      return "canceled";
    default:
      return statusCode;
  }
}
export function getType(typeCode) {
  switch (typeCode) {
    case 1:
      return "One Way";
    case 2:
      return "Two Way";
    default:
      return typeCode;
  }
} 
 
export function getPaymentMethod(methodID) {
  switch (methodID) {
    case cardTypes.cc:
      return "Credit Card";

    case cardTypes.cash:
      return "Fawry - Aman";

    default:
      return "Unknown"
  }
}

export const loaderstyle = {
  overlay: (base) => ({
    ...base,
    background: '#fff'
  }),
  spinner: (base) => ({
    ...base,
    width: '100px',
    '& svg circle': {
      stroke: '#073E7E'
    }
  }),
  content: (base) => ({
    ...base,
    margin: '5% auto'
  })
}

export const muiTheme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: green,
    error: red
  },
  status: {
    danger: 'orange',
  },
});
export const materialUiStyles = theme => ({
  root: {
    flexGrow: 1
  },
  progress: {
    margin: theme.spacing(2),
    color: "#00695c"
  },
  linearColorPrimary: {
    backgroundColor: "#b2dfdb"
  },
  linearBarColorPrimary: {
    backgroundColor: "#00695c"
  },
  circular_progress: {
    color: "#6798e5",
    animationDuration: "550ms",
    position: "absolute"
  },
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  margin: {
    margin: theme.spacing(1)
  }
}); 

